import { render, staticRenderFns } from "./right-config.vue?vue&type=template&id=9f3e8226"
import script from "./right-config.vue?vue&type=script&lang=js"
export * from "./right-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports